import React, { HTMLAttributes, useContext, useState } from "react";
import ConfigContext from "contexts/ConfigContext";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import MediaSkeleton from "components/skeletons/MediaSkeleton";
import calculateAspectRatio from "utils/calculateAspectRatio";
import imageSizes from "imageSizes";
import playButtonBackground from "assets/images/homePage/bannerSection/video/btn_play_bg.png";
import PlayButtonOutline from "assets/svgs/icons/PlayButtonOutline";
import Glitch from "components/glitch/Glitch";
import VideoDialog from "components/dialogs/VideoDialog";
import videoBackgroundImageSrc from "assets/videos/homepage/video_bg.png";
import videoFrameImage from "assets/videos/homepage/video_innerframe.png";

// import video from "assets/videos/homepage/playgrounds/playgroundsHompageVideo.mp4";
// import videoPlaceholder from "assets/videos/homepage/playgrounds/playgroundsHompageVideo.jpg";
// const aspectRatio = calculateAspectRatio(imageSizes.homePage.bannerVideo.playgrounds);

// import video from "assets/videos/homepage/announcement/announcementHompageVideo.mp4";
// import videoPlaceholder from "assets/videos/homepage/announcement/announcementHompageVideo.jpg";
// const aspectRatio = calculateAspectRatio(imageSizes.homePage.bannerVideo.announcement);

import video from "assets/videos/homepage/launch/launchVideoLoop.mp4";
import videoPlaceholder from "assets/videos/homepage/launch/launchVideoLoop.jpg";
const aspectRatio = calculateAspectRatio(imageSizes.homePage.bannerVideo.launch);

const useStyles = makeStyles((theme: Theme) => {
    const videoZIndex = 5;

    return createStyles({
        root: {
            position: "relative",
            overflow: "hidden",
            display: "flex",
        },
        videoContainer: {
            flex: "1",
            zIndex: videoZIndex,
            "& video": {
                width: "100%",
            },
            backgroundImage: `url(${videoBackgroundImageSrc})`,
            backgroundSize: "100% 100%",
            paddingTop: "1.2%",
            paddingLeft: "1.3%",
            paddingBottom: "1.8%",
            paddingRight: "2.5%",
            position: "relative",
        },
        videoFrame: {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            zIndex: videoZIndex + 1,
        },

        content: {
            cursor: "pointer",
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: videoZIndex + 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.common.white,
            "&:hover": {
                "& $playButton": { opacity: 1 },
                "& $playButtonOutline": { display: "none" },
                "& $playButtonGlitchOutline": { display: "block" },
            },
        },
        playButton: {
            width: 100,
            position: "relative",
            "& img": {
                width: "100%",
            },
            opacity: 0.8,
        },
        playButtonOutline: {},
        playButtonGlitchOutline: { display: "none" },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function BannerVideo(props: IProps) {
    const classes = useStyles();
    const { className, ...rest } = props;

    const [videoDialogIsOpen, setVideoDialogIsOpen] = useState<boolean>(false);

    const config = useContext(ConfigContext);

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <div className={classes.videoContainer}>
                <div style={{ position: "relative" }}>
                    <img src={videoFrameImage} className={classes.videoFrame} alt="" />
                    <MediaSkeleton aspectRatio={aspectRatio} hideBackground>
                        {/* https://stackoverflow.com/questions/34764876/html-5-video-autoplay-not-automatically-starting-in-chrome */}
                        <video
                            src={video}
                            poster={videoPlaceholder}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </MediaSkeleton>
                </div>
            </div>
            {typeof config === "undefined" ? null : (
                <>
                    <div onClick={() => setVideoDialogIsOpen(true)} className={classes.content}>
                        <div className={classes.playButton}>
                            <div
                                style={{
                                    width: "80%",
                                    height: "100%",
                                    position: "absolute",
                                    top: 5,
                                    left: 7,
                                }}
                            >
                                <div className={classes.playButtonOutline}>
                                    <PlayButtonOutline />
                                </div>
                                <Glitch className={classes.playButtonGlitchOutline}>
                                    <PlayButtonOutline />
                                </Glitch>
                            </div>
                            <img src={playButtonBackground} alt="Play button" />
                        </div>
                    </div>
                    <VideoDialog
                        open={videoDialogIsOpen}
                        videoId={config.media.homepageYouTubeVideoId}
                        onClose={() => setVideoDialogIsOpen(false)}
                    />
                </>
            )}
        </div>
    );
}
